import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import stylex from '@stylexjs/stylex';
import { FloatingDelayGroup } from '@floating-ui/react';
import { darkColorSchemeTheme } from '../../themes/base/darkColorScheme.styles';
import { themeProviderStyles, useThemeContext } from '../../components/Theme';
import { colorSchemeTheme } from '../../themes/base/colorScheme.stylex';
import { ColorSchemeContext, } from './ColorScheme.context';
import { colorSchemeProviderStyles } from './ColorSchemeProvider.styles';
import { useColorScheme } from './useColorScheme';
export const ColorSchemeProvider = (props) => {
    const { sx, variant, children } = props;
    const root = useRef(null);
    const themeContext = useThemeContext();
    const currentColorScheme = useColorScheme();
    const isDark = variant === 'dark';
    const isLight = !isDark;
    const shouldUpdatColorScheme = currentColorScheme.variant !== variant;
    return (_jsx(ColorSchemeContext.Provider, { value: { variant, root }, children: _jsx(FloatingDelayGroup, { delay: {
                open: 100,
                close: 1500,
            }, children: _jsx("div", { ...stylex.props(colorSchemeProviderStyles.host, isLight && colorSchemeProviderStyles.container$light, isLight &&
                    shouldUpdatColorScheme && [
                    colorSchemeTheme,
                    themeContext.theme.schemes &&
                        themeProviderStyles.dynamicScheme(themeContext.theme.schemes.light),
                ], isDark && colorSchemeProviderStyles.container$dark, isDark &&
                    shouldUpdatColorScheme && [
                    darkColorSchemeTheme,
                    themeContext.theme.schemes &&
                        themeProviderStyles.dynamicScheme(themeContext.theme.schemes.dark),
                ], sx), ref: root, "data-scheme": variant, children: children }) }) }));
};
